import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import OrderModal from './components/OrderModal'
import { OrderModalProvider } from './contexts/OrderModalContext'
import Home from './pages/Home'
import Order from './pages/Order'
import Login from './pages/Login'
import Admin from './pages/Admin'
import NaszeRealizacje from './pages/NaszeRealizacje'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

export default function App() {
  return (
    <OrderModalProvider>
      <Router>
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <Header />
          <main style={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/realizacje" element={<NaszeRealizacje />} />
              <Route path="/zamowienie" element={<Order />} />
              <Route path="/zamovlennya" element={<Order />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </main>
          <Footer />
          <OrderModal />
        </div>
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Router>
    </OrderModalProvider>
  )
}
